<template>
  <div>
    <el-dialog
      class="dialog--login-as"
      title="Danh sách công ty"
      :visible.sync="dialogVisibleComnpany"
      :close-on-click-modal="false"
      :before-close="handleCloseCompany"
    >
      <el-row :gutter="20" class="search--block mb-2">
        <el-col :md="20">
          <el-input
            autocomplete="false"
            v-model="companyTableRules.dataSearch.value.search"
            clearable
            placeholder="Nhập Tên, Tên viết tắt, Mã số thuế, Email (Enter để tìm kiếm)"
            prefix-icon="fal fa-search"
            @keyup.enter.native="fn_filterCompany"
          />
        </el-col>
        <el-col :md="4">
          <el-button type="primary" class="w-100" @click="fn_filterCompany">
            Tìm kiếm
          </el-button>
        </el-col>
      </el-row>
      <el-table
        :data="listCompanys"
        :max-height="height"
        style="width: 100%"
        border
      >
        <el-table-column label="STT" width="50" align="center">
          <template slot-scope="scope">
            {{ companyTableRules.offset + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column label="Logo" align="center" width="130">
          <template slot-scope="scope">
            <el-image
              v-if="scope.row.logo_id"
              style="width: 100px; height: 100px"
              :src="getUrlImage(scope.row.logo_id)"
              fit="contain"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column
          prop="name.name_vi"
          label="Tên công ty"
        ></el-table-column>
        <el-table-column
          prop="name.abbreviation_name"
          label="Tên viết tắt"
          width="100"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.name.abbreviation_name.toUpperCase() }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="account"
          label="Tài khoản"
          width="120"
        ></el-table-column>
        <el-table-column label="Khóa" width="60" align="center">
          <template slot-scope="scope">
              <el-checkbox
                v-model="scope.row.disabled"
                disabled
              />
          </template>
        </el-table-column>
        <el-table-column align="center" label="Thao tác" width="110">
          <template slot-scope="scope">
            <el-button
              class="button-action login-as"
              size="mini"
              plain
              round
              @click="loginAs(scope.row.account)"
              v-b-popover.hover.left="'Đăng nhập'"
            >
              <i class="icon isax-login"></i>
            </el-button>
            <el-button
              class="button-action list-user"
              size="mini"
              plain
              round
              @click="getAllEmployeeByCompany(scope.row.id)"
              v-b-popover.hover.left="'Nhân viên'"
            >
              <i class="icon isax-user-octagon"></i>
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="mt-2 text-right">
        <el-pagination
          @size-change="fn_tableCompanySizeChange"
          @current-change="fn_tableCompanyCurentChange"
          @prev-click="fn_tableCompanyPrevClick"
          @next-click="fn_tableCompanyNextClick"
          :page-sizes="companyTableRules.lengthMenu"
          :page-size="companyTableRules.limit"
          :current-page="companyTableRules.page"
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="companyTableRules.total"
          :pager-count="5"
        ></el-pagination>
      </div>
    </el-dialog>
    <el-dialog
      class="dialog--login-as"
      title="Danh sách nhân viên"
      :visible.sync="dialogVisibleEmployeeByComnpany"
      :before-close="handleCloseEmployeeByCompany"
    >
      <el-row :gutter="20" class="search--block mb-2">
        <el-col :md="20">
          <el-input
            autocomplete="false"
            v-model="employeeTableRules.dataSearch.value.search"
            clearable
            placeholder="Nhập Mã nhân viên, Họ và tên, Số điện thoại, Số CMND/CCCD, Email (Enter để tìm kiếm)"
            prefix-icon="fal fa-search"
            @keyup.enter.native="fn_filterEmployee"
          />
        </el-col>
        <el-col :md="4">
          <el-button type="primary" class="w-100" @click="fn_filterEmployee">
            Tìm kiếm
          </el-button>
        </el-col>
      </el-row>
      <el-table
        :data="employeeTableRules.data"
        :max-height="height"
        style="width: 100%"
        border
      >
        <el-table-column label="STT" width="50" align="center">
          <template slot-scope="scope">
            {{ employeeTableRules.offset + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column label="Ảnh đại diện" width="130" align="center">
          <template slot-scope="scope">
            <el-image
              style="width: 100px; height: 100px"
              :src="
                getUrlImage(
                  scope.row.image_id
                    ? scope.row.image_id
                    : scope.row.administrative_info.avatar_id
                )
              "
              fit="contain"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column
          prop="employee_no"
          label="Mã nhân viên"
          width="150"
          align="center"
        />
        <el-table-column
          prop="administrative_info.name.full_name"
          label="Tên nhân viên"
          min-width="180"
        />
        <el-table-column label="Ngày sinh" width="110" align="center">
          <template slot-scope="scope">
            {{
              MethodService.formatDate(
                scope.row.administrative_info.birthday,
                "date"
              )
            }}
          </template>
        </el-table-column>
        <el-table-column
          prop="administrative_info.email"
          label="Email"
          min-width="130"
        />
        <el-table-column prop="account" label="Tài khoản" width="150" />
        <el-table-column label="Khóa" width="60" align="center">
          <template slot-scope="scope">
            <el-checkbox
              v-model="scope.row.disabled"
              disabled
            />
          </template>
        </el-table-column>
        <el-table-column align="center" label="Thao tác" width="80">
          <template slot-scope="scope">
            <el-button
              class="button-action login-as"
              size="mini"
              plain
              round
              @click="loginAs(scope.row.account)"
              v-b-popover.hover.left="'Đăng nhập'"
            >
              <i class="icon isax-login"></i>
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="mt-2 text-right">
        <el-pagination
          @size-change="fn_tableEmployeeSizeChange"
          @current-change="fn_tableEmployeeCurentChange"
          @prev-click="fn_tableEmployeePrevClick"
          @next-click="fn_tableEmployeeNextClick"
          :page-sizes="employeeTableRules.lengthMenu"
          :page-size="employeeTableRules.limit"
          :current-page="employeeTableRules.page"
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="employeeTableRules.total"
          :pager-count="5"
        ></el-pagination>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import ExtensionService from '../../service/ExtensionService'
import MethodService from '../../service/MethodService'
import CompanyApi from '../../moduleApi/CompanyApi'
import UserApi from '../../moduleApi/UserApi'
import EmployeeApi from '../../moduleApi/EmployeeApi'
import toastr from 'toastr'
import EventBus from "@/service/EventBus";

export default {
  props: {
    dialogVisibleComnpanyProp: {
      type: Boolean,
      default: () => {
        false
      },
    },
  },
  data() {
    return {
      test: undefined,
      MethodService,
      ExtensionService,
      dialogVisibleComnpany: false,
      dialogVisibleEmployeeByComnpany: false,
      listCompanys: [],
      companyChossedId: undefined,
      height: window.innerHeight - 260,
      companyTableRules: {
        filters: undefined,
        lengthMenu: [10, 20, 50, 100],
        total: 0,
        page: 1,
        limit: 10,
        offset: 0,
        dataSearch: {
          value: {
            search: undefined
          },
          operator: {
            search: '$vn_text='
          }
        },
      },
      employeeTableRules: {
        data: [],
        filters: undefined,
        lengthMenu: [10, 20, 50, 100],
        total: 0,
        page: 1,
        limit: 10,
        offset: 0,
        dataSearch: {
          value: {
            search: undefined
          },
          operator: {
            search: '$vn_text='
          }
        },
      },
    }
  },
  methods: {
    // This function is used to login as other account.
    async loginAs(account) {
      const loginAsRes = await UserApi.LoginOtherAccount({
        account: account,
      })
      if (loginAsRes.result) {
        localStorage.setItem(
          `mushroom.tokens[${window.MyConfig.hostApi}]`,
          loginAsRes.result
        )
        this.$emit('closedialogVisibleComnpany')
        EventBus.$emit("saveFirebaseToken");
        window.location.reload()
      } else {
        toastr.warning('Tài khoản này hiện không khả dụng để truy cập!')
      }
    },
    async getAllEmployeeByCompany(companyId) {
      this.companyChossedId = companyId
      const employeeByCompanyIdRes = await EmployeeApi.list({
        filters: `${this.employeeTableRules.filters ? this.employeeTableRules.filters + '&' : ''}company_id=${companyId}`,
        limit: this.employeeTableRules.limit,
        offset: this.employeeTableRules.offset,
        fields: 'administrative_info,employee_no,account,image_id,disabled',
      })
      this.employeeTableRules.data = employeeByCompanyIdRes.result
      this.employeeTableRules.total = employeeByCompanyIdRes.meta.total
      this.employeeTableRules.page =
        employeeByCompanyIdRes.meta.offset / employeeByCompanyIdRes.meta.limit +
        1
      this.dialogVisibleEmployeeByComnpany = true
    },
    // A function that get all company from API.
    async getAllCompany() {
      const companyApiRes = await CompanyApi.list({
        filters: this.companyTableRules.filters,
        sort: 'name.name_vi',
        limit: this.companyTableRules.limit,
        offset: this.companyTableRules.offset,
      })
      this.listCompanys = this.changeData(companyApiRes.result)
      this.companyTableRules.total = companyApiRes.meta.total
      this.companyTableRules.page =
        companyApiRes.meta.offset / companyApiRes.meta.limit + 1
    },
    // A function that change data.
    changeData(data) {
      data.forEach((item) => {
        item.account = `${item.name.abbreviation_name.toLowerCase()}_admin`
      })
      return data
    },
    // A function that close the dialog.
    handleCloseCompany(done) {
      this.$emit('closedialogVisibleComnpany')
      done()
    },
    // A function that close the dialog.
    handleCloseEmployeeByCompany(done) {
      this.employeeTableRules.dataSearch.value.search = undefined
      this.employeeTableRules.filters = undefined
      this.employeeTableRules.limit = 10
      this.employeeTableRules.offset = 0
      this.employeeTableRules.page = 1
      done()
    },
    // A function that get the url of image.
    getUrlImage(id) {
      return ExtensionService.urlImg + id
    },
    // A method that is called when the user types in the search box.
    fn_filterCompany() {
      this.companyTableRules.filters = MethodService.filterTable(JSON.stringify(this.companyTableRules.dataSearch))
      this.companyTableRules.offset = 0
      this.companyTableRules.sort = ''
      this.getAllCompany()
    },
    fn_filterEmployee() {
      this.employeeTableRules.filters = MethodService.filterTable(JSON.stringify(this.employeeTableRules.dataSearch))
      this.employeeTableRules.offset = 0
      this.employeeTableRules.sort = ''
      this.getAllEmployeeByCompany(this.companyChossedId)
    },
    fn_tableCompanySizeChange(limit) {
      this.companyTableRules.limit = limit
      this.fn_tableCompanyChangeOffset(this.companyTableRules.page)
    },
    fn_tableCompanyCurentChange(page) {
      this.fn_tableCompanyChangeOffset(page)
    },
    fn_tableCompanyPrevClick(page) {
      this.fn_tableCompanyChangeOffset(page)
    },
    fn_tableCompanyNextClick(page) {
      this.fn_tableCompanyChangeOffset(page)
    },
    fn_tableCompanyChangeOffset(page) {
      this.companyTableRules.page = page
      this.companyTableRules.offset =
        (this.companyTableRules.page - 1) * this.companyTableRules.limit
      this.getAllCompany()
    },

    //Event table Employee
    fn_tableEmployeeSizeChange(limit) {
      this.employeeTableRules.limit = limit
      this.fn_tableEmployeeChangeOffset(this.employeeTableRules.page)
    },
    fn_tableEmployeeCurentChange(page) {
      this.fn_tableEmployeeChangeOffset(page)
    },
    fn_tableEmployeePrevClick(page) {
      this.fn_tableEmployeeChangeOffset(page)
    },
    fn_tableEmployeeNextClick(page) {
      this.fn_tableEmployeeChangeOffset(page)
    },
    fn_tableEmployeeChangeOffset(page) {
      this.employeeTableRules.page = page
      this.employeeTableRules.offset =
        (this.employeeTableRules.page - 1) * this.employeeTableRules.limit
      this.getAllEmployeeByCompany(this.companyChossedId)
    },
  },
  created() {
    this.dialogVisibleComnpany = false
    this.dialogVisibleEmployeeByComnpany = false
    if (MethodService.checkRole('AdminSystem')) this.getAllCompany()
  },
  watch: {
    dialogVisibleComnpanyProp(newVal) {
      this.dialogVisibleComnpany = newVal
      if (MethodService.checkRole('AdminSystem')) this.getAllCompany()
    },
  },
}
</script>
<style lang="scss" scoped>
.button-action {
  width: 22px;
  border: none;
  padding: 0;
  background: transparent;
  margin-right: 5px;
  &:hover {
    background: transparent !important;
    border: none !important;
  }
  .icon {
    &::before {
      font-size: 22px;
    }
  }
  &.login-as {
    color: #f12727;
    &:hover {
      color: #f12727;
    }
  }
  &.list-user {
    color: #4f8aab;
    &:hover {
      color: #4f8aab !important;
    }
  }
}
::v-deep .el-checkbox__input{
  &.is-disabled {
    &.is-checked {
      .el-checkbox__inner {
        border-color: var(--orange) !important;
        background-color: var(--orange);
        &::after {
          border-color: #fff;
        }
      }
    }
  }
}
::v-deep .dialog--login-as {
  .el-dialog {
    width: 75%;
    margin-top: 4vh !important;
  }
}
</style>
